import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Layout from '../views/layout/layout';

import LoginView from '../views/login/loginview';
import SalesOrder from '../views/salesOrder';
import AddSalesOrder from '../components/salesOrder/addSalesOrder';
import EditSalesOrder from '../components/salesOrder/editSalesOrder';
import CustomerInvoice from '../views/customerInvoice';
import AddCustomerInvoice from '../components/customerInvoice/addCustomerInvoice';
import EditCustomerInvoice from '../components/customerInvoice/editCustomerInvoice';
import Receivables from '../views/receivables';
import AddReceivable from '../components/receivable/addReceivable';
import EditReceivable from '../components/receivable/editReceivable';
import Product from '../views/masters/product';
import Expense from '../views/masters/expense';
import Branch from '../views/masters/branch';
import Consignee from '../views/masters/consignee';
import AddConsignee from '../components/mastersComponents/consignee/addConsignee';
import EditConsignee from '../components/mastersComponents/consignee/editConsignee';
import BillingParty from '../views/masters/billingParty';
import AddBillingParty from '../components/mastersComponents/billingParty/addBillingParty';
import EditBillingParty from '../components/mastersComponents/billingParty/editBillingParty';
import Consignor from '../views/masters/consignor';
import addConsignor from '../components/mastersComponents/consignor/addConsignor';
import editConsignor from '../components/mastersComponents/consignor/editConsignor';

import Target from '../views/masters/target';
import AddTarget from '../components/mastersComponents/target/addTarget';
import EditTarget from '../components/mastersComponents/target/editTarget';
import { LOCAL_STORAGE } from '../components/utils/constants';
import ViewCustomerInvoice from '../components/customerInvoice/viewInvoice';
import CreditNote from '../views/creditNote';
import AwsReports from '../views/awsReports/awsReports';

class Routes extends Component {
    render() {
        return (
            <React.Fragment>
                <Layout>
                    <Switch>
                        {LOCAL_STORAGE.role === "User" ?
                            <>
                                <Route path="/" exact render={() => (LOCAL_STORAGE.userToken ? (<Redirect to='/' />) : (<LoginView />))} />
                                <Route path="/" exact render={() => (LOCAL_STORAGE.userToken ? (<Redirect to='/' />) : (<LoginView />))} />
                            </>
                            :
                            <>
                                <Route path="/" exact render={() => (LOCAL_STORAGE.userToken ? (<Redirect to='/' />) : (<LoginView />))} />

                                <Route path="/salesorder" exact component={LOCAL_STORAGE.userToken ? SalesOrder : LoginView} />
                                <Route path="/add-salesorder" exact component={LOCAL_STORAGE.userToken ? AddSalesOrder : LoginView} />
                                <Route path="/edit-salesorder" exact component={LOCAL_STORAGE.userToken ? EditSalesOrder : LoginView} />

                                <Route path="/customerinvoice" exact component={LOCAL_STORAGE.userToken ? CustomerInvoice : LoginView} />
                                <Route path="/add-customerinvoice" exact component={LOCAL_STORAGE.userToken ? AddCustomerInvoice : LoginView} />
                                <Route path="/edit-customerinvoice" exact component={LOCAL_STORAGE.userToken ? EditCustomerInvoice : LoginView} />
                                <Route path="/view-invoice" exact component={LOCAL_STORAGE.userToken ? ViewCustomerInvoice : LoginView} />

                                <Route path="/credit-note" exact component={LOCAL_STORAGE.userToken ? CreditNote : LoginView} />
                                <Route path="/receivable" exact component={LOCAL_STORAGE.userToken ? Receivables : LoginView} />
                                <Route path="/add-receivable" exact component={LOCAL_STORAGE.userToken ? AddReceivable : LoginView} />
                                <Route path="/edit-receivable" exact component={LOCAL_STORAGE.userToken ? EditReceivable : LoginView} />
                                <Route path='/billingparty' exact component={LOCAL_STORAGE.userToken ? BillingParty : LoginView} />
                                <Route path='/add_billing_party' exact component={LOCAL_STORAGE.userToken ? AddBillingParty : LoginView} />
                                {/* <Route path="/billingparty" exact component={LOCAL_STORAGE.userToken ? BillingParty : LoginView} />
                                <Route path="/add_billing_party" exact component={LOCAL_STORAGE.userToken ? AddBillingParty : LoginView} /> */}
                                <Route path="/edit-billingparty" exact component={LOCAL_STORAGE.userToken ? AddBillingParty : LoginView} />

                                <Route path="/consignee" exact component={LOCAL_STORAGE.userToken ? Consignee : LoginView} />
                                <Route path="/add-consignee" exact component={LOCAL_STORAGE.userToken ? AddConsignee : LoginView} />
                                <Route path="/edit-consignee" exact component={LOCAL_STORAGE.userToken ? EditConsignee : LoginView} />

                                <Route path="/consignor" exact component={LOCAL_STORAGE.userToken ? Consignor : LoginView} />
                                <Route path="/add-consignor" exact component={LOCAL_STORAGE.userToken ? addConsignor : LoginView} />
                                <Route path="/edit-consignor" exact component={LOCAL_STORAGE.userToken ? editConsignor : LoginView} />


                                <Route path="/branch" exact component={LOCAL_STORAGE.userToken ? Branch : LoginView} />

                                <Route path="/expense" exact component={LOCAL_STORAGE.userToken ? Expense : LoginView} />

                                <Route path="/product" exact component={LOCAL_STORAGE.userToken ? Product : LoginView} />



                                <Route path="/target" exact component={LOCAL_STORAGE.userToken ? Target : LoginView} />
                                <Route path="/add-target" exact component={LOCAL_STORAGE.userToken ? AddTarget : LoginView} />
                                <Route path="/edit-target" exact component={LOCAL_STORAGE.userToken ? EditTarget : LoginView} />

                                <Route path="/reportsheet" exact component={LOCAL_STORAGE.userToken ? AwsReports : LoginView} />
                            </>
                        }
                    </Switch>
                </Layout>
            </React.Fragment>
        )
    }
}

export default Routes